<!-- 实名认证 -->
<template>
  <div class="personalAuthentication_box">
    <div v-if="state == 1 && status == 6" class="authenticationN_box">
      <div class="title">实名认证</div>
      <el-form :model="form" :rules="rules" label-width="400px" ref="form">
        <el-form-item ref="contractFile" label="上传注册人身份证" prop="contractFile">
          <div class="imgWrapper">
            <el-upload class="upload-demo" action :auto-upload="false" :on-preview="handlePreview" :on-remove="
                  (file, fileList) => {
                    handleRemove(file, fileList, 'contractFile');
                  }
                " :on-change="
                  (file, fileList) => {
                    handleChange(file, fileList, 'contractFile');
                  }
                " :on-exceed="handleExceed" :file-list="contractFileFileList" accept=".jpg,.png">
              <div class="imgBox">
                <div class="imgBody" v-if="!addrList.contractFileAddress">
                  <i class="el-icon-plus"></i>
                  上传照片
                </div>
                <div class="imgfooter" v-if="addrList.contractFileAddress">
                  <img :src="lxrSfzUrl" alt="" width="100%" height="100%" />
                  <div class="imgTxt">
                    重新上传
                  </div>
                </div>
              </div>
            </el-upload>
            <el-upload class="upload-demo" action :auto-upload="false" :on-preview="handlePreview" :on-remove="
                  (file, fileList) => {
                    handleRemove(file, fileList, 'corporaIdCarBFile');
                  }
                " :on-change="
                  (file, fileList) => {
                    handleChange(file, fileList, 'corporaIdCarBFile');
                  }
                " :on-exceed="handleExceed" :file-list="corporaIdCarBFileList" accept=".jpg,.png">
              <div class="imgBox" style="margin-left:20px">
                <div class="imgBody" v-if="!addrList.corporaIdCarBFileAddr">
                  <i class="el-icon-plus"></i>
                  国徽页
                </div>
                <div class="imgfooter" v-if="addrList.corporaIdCarBFileAddr">
                  <img :src="lxrsfzfmUrl" alt="" width="100%" height="100%" />
                  <div class="imgTxt">
                    重新上传
                  </div>
                </div>
              </div>

            </el-upload>
            <div slot="tip" class="el-upload__tip" style="margin-left:20px">
              照片信息清晰可见，内容真实有效，支持上传格式：JPG,
              PNG
            </div>
          </div>
        </el-form-item>
        <el-form-item label="姓名" prop="contactName">
          <el-input show-word-limit minlength="2" maxlength="4" clearable v-model="form.contactName">
          </el-input>
        </el-form-item>
        <el-form-item label="身份证号码" prop="contractIdNumber">
          <el-input show-word-limit maxlength="18" clearable v-model="form.contractIdNumber">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submit">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="success_box" v-if="state == 2">
      <img src="@/assets/rzsuccess.png" class="success_img">
      <div class="success_text">实名认证通过</div>
      <div class="success_btn" v-if="state == 2">
        <el-button @click="check">查看认证信息</el-button>
        <el-button type="primary" @click="toEnterpriseInformation">前往企业认证</el-button>
      </div>
    </div>
    <div class="authenticationY_box" v-if="state == 3 && status != 6">
      <div class="authenticationY_title">实名认证信息</div>
      <el-row :gutter="20">
        <el-col :span="8">
          <div><span class="label">姓名：</span><span class="value">{{customerDetail.contactName}}</span><span class="state"><span class="state" v-if="status != 6 "><img src="@/assets/certified.png" alt="" class="state_img"></span></span></div>
        </el-col>
        <el-col :span="8">
          <div><span class="label">身份证号：</span>
            <!-- <span class="value">{{customerDetail.contractIdNumber}}</span> -->
            <table-column-decrypt  :key="Math.random()" class="value" :decrypt-dto="customerDetail.contractIdNumberDto" :src-value="customerDetail.contractIdNumber" />
          </div>
        </el-col>
        <el-col :span="8">
          <div><span class="label">手机号：</span>
            <!-- <span class="value">{{customerDetail.contactPhone}}</span> -->
            <table-column-decrypt  :key="Math.random()" class="value" :decrypt-dto="customerDetail.contactPhoneDto" :src-value="customerDetail.contactPhone" />
          </div>
        </el-col>

      </el-row>
    </div>
  </div>
</template>
<script>
import getMvcUrl from "../../utils/mvcUrlUtil.js";
import { formatDate } from "@/common/js/date.js";
import { mapActions } from "vuex";
import fetchPost from "@/api/http.js";
import moment from "moment";
import tableColumnDecrypt from '@/components/table-column-decrypt.vue';

export default {
  components: {
    tableColumnDecrypt
  },
  data() {
    const contractFileValidate = (rule, value, callback) => {
      if (this.contractFileFileList.length == "0" && !this.addrList.contractFileAddress) {
        callback(new Error("请上传注册人身份证头像页"));
      } else if (this.corporaIdCarBFileList.length == "0" && !this.addrList.corporaIdCarBFileAddr) {
        callback(new Error("请上传注册人身份证国徽页"));
      } else {
        callback();
      }
    };
    const validcontactName = (rule, value, callback) => {
      //console.log(value)
      if (!value) {
        return callback(new Error("请输入姓名"));
      } else if (value.length < 2 || value.length > 4) {
        return callback(new Error("请输入2-4个汉字"));
      } else {
        callback();
      }
    };
    const validIdCard = (rule, value, callback) => {
      let msr =
        /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X|x)$/;
      if (!msr.test(value)) {
        callback(new Error("请输入正确的18位身份证号码"));
      } else {
        callback();
      }
    };

    return {
      form: {
        customerNo: JSON.parse(sessionStorage.getItem("userInfo")).customerNo,
        contactName: "",
        contractIdNumber: "",
        termOfValidity: "",
        contractFileAddress: "",
        corporaIdCarBFileAddr: "",
        sources: "saas"
      },
      rules: {
        contractFile: [
          { required: true, validator: contractFileValidate, trigger: "change" },
        ],
        contactName: [
          { required: true, validator: validcontactName, trigger: "blur" },
        ],
        contractIdNumber: [
          { required: true, validator: validIdCard, trigger: "blur" },
        ],
      },
      addrList: {
        contractFileAddress: "", //注册人身份证件地址
        corporaIdCarBFileAddr: "", //注册人身份证件反面
      },
      contractFileFileList: [],
      corporaIdCarBFileList: [],
      fileArr: [
        { fileName: 'contractFile', listName: 'contractFileFileList', type: 'idCard' },
        { fileName: 'corporaIdCarBFile', listName: 'corporaIdCarBFileList', type: 'idCard' },
      ],
      state: 1,
      formData: "",
      lxrSfzUrl: "",
      lxrsfzfmUrl: "",
      status: "",
      customerDetail: ""
    }
  },
  mounted() {
    this.formData = new window.FormData();
    this.imgBaseUrl = getMvcUrl() + "/saas/companyQualification/viewImage?objectName=";
    this.queryByCustomerNo();
  },
  methods: {
    ...mapActions([
      "personAuthenticationForSaasApi",
      "queryByCustomerNoAPI",
    ]),
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) { },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleChange(file, fileList, val) {
      let size = Number(file.size / 1024 / 1024);
      let pass;
      if (size > 5) {
        this.$message.warning('文件大小不能超过5MB，请重新上传');
        pass = false;
      } else {
        pass = true;
      }
      this.fileArr.forEach(item => {
        if (item.fileName == val) {
          this[item.listName] = [];
          if (pass) {
            this[item.listName] = [];
            this[item.listName].push(file);
          } else {
            this.formData.delete(item.fileName);
          }
          this.formData.delete(item.fileName);
          this.formData.append(item.fileName, file.raw);

          // this.getBase64(file.raw).then(resBase64 => {
          //   if (val == 'contractFile') {
          //     this.addrList.contractFileAddress = resBase64.split(',')[1];
          //     this.lxrSfzUrl = resBase64;
          //   } else {
          //     this.addrList.corporaIdCarBFileAddr = resBase64.split(',')[1];
          //     this.frsfzfmUrl = resBase64;
          //   }
          // })
          if (item.type == 'idCard') {
            this.$refs.contractFile.clearValidate();
          } else if (item.type == 'lxrCard') {
            this.$refs.contractFile.clearValidate();
          } else {
            this.$refs[item.fileName].clearValidate();
          }
          let idCardSide = "";
          if (val == 'contractFile') {
            idCardSide = "front";
          } else {
            idCardSide = "back";
          }
          this.ocrDistinguish(idCardSide, file.raw);
        }
      })
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        let fileResult = "";
        reader.readAsDataURL(file);
        //开始转
        reader.onload = function () {
          fileResult = reader.result;
        };
        //转 失败
        reader.onerror = function (error) {
          reject(error);
        };
        //转 结束  咱就 resolve 出去
        reader.onloadend = function () {
          resolve(fileResult);
        };
      });
    },
    handleRemove(file, fileList, val) {
      this.fileArr.forEach(item => {
        if (item.fileName == val) {
          this[item.listName] = [];
          this.formData.delete(item.fileName)
        }
      })
    },
    ocrDistinguish(idCardSide, file) {
      this.formData.delete("file");
      this.formData.append("file", file);
      fetchPost("/saas/ocr/idCard/" + idCardSide, this.formData)
        .then(
          res => {
            if(res.imgInfo.imageStatus == "other_type_card"){
              this.$message({
                type: "error",
                message: "请上传正确的身份证件",
              });
              return;
            }   
            if (idCardSide == "front") {
              this.addrList.contractFileAddress = res.imgPath;
              this.lxrSfzUrl = this.imgBaseUrl + res.imgPath;
              this.form.contactName = res.imgInfo.name;
              this.form.contractIdNumber = res.imgInfo.idNo;
            } else {
              this.addrList.corporaIdCarBFileAddr = res.imgPath;
              this.lxrsfzfmUrl = this.imgBaseUrl + res.imgPath;
              this.form.termOfValidity = this.getData(res.imgInfo.dateOfIssue) + "-" + this.getData(res.imgInfo.expiryDate);
              let expiryDate = this.getData(res.imgInfo.expiryDate,1);
              if(moment(new Date(expiryDate)) < moment(new Date())){
                this.$message({
                  type: "error",
                  message: "身份证已过有效期限",
                });
                return;
              } 
            }
          }
        );
    },
    getData(val,type) {
      if(val){
        let year = val.slice(0, 4);
        let month = val.slice(4, 6);
        let date = val.slice(6, 8);
        if(type && type == 1){
          return year + "-" + month + "-" + date
        }else {
          return year + "." + month + "." + date
        }   
      }   
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          console.log("ok");
          this.formData.delete("file");
          let params = JSON.parse(JSON.stringify(this.form));
          this.formData.delete("param");
          this.formData.append("param", JSON.stringify(params));
          this.personAuthenticationForSaasApi(this.formData).then((res) => {
            if (res) {
              this.state = 2;
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    toEnterpriseInformation() {
      this.$router.push("/manage/enterpriseCertification");
    },
    //查看认证信息
    check() {
      this.queryByCustomerNo();
      this.state = 3;
    },
    queryByCustomerNo() {
      // 进入页面回显相关信息
      let params = {
        customerNo: this.form.customerNo,
      };
      this.queryByCustomerNoAPI(params).then((res) => {
        let { customerDetail, historyList } = res;
        this.status = customerDetail.status;
        this.customerDetail = customerDetail;
        if (this.status != 6) {
          this.state = 3;
        }
      });
    },
  }
}
</script>
<style lang="less" scoped>
.title {
  font-size: 16px;
  color: #000000;
  letter-spacing: 0;
  font-weight: bold;
  padding: 24px 0 127px 32px !important;
}
/deep/ .el-form-item__content {
  width: 600px !important;
}
/deep/ .el-form-item {
  margin-bottom: 32px !important;
}
/deep/ .el-upload-list__item-name {
  width: 98px;
  margin-right: 0 !important;
}
.imgWrapper {
  display: flex;
}
.imgBox {
  width: 80px;
  height: 80px;
  background: rgba(0, 0, 0, 0.02);
  border: 0.8px dashed rgba(0, 0, 0, 0.15);
  border-radius: 3px;
  position: relative;
  display: inline-block;
  .imgBody {
    width: 100%;
    height: 100%;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.65);
    line-height: 17.63px;
    font-weight: 400;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .el-icon-plus {
      width: 20px;
      height: 20px;
    }
  }
  .imgfooter {
    width: 100%;
    height: 100%;
    background-color: #f5f5f5;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .imgTxt {
      position: absolute;
      height: 30px;
      line-height: 30px;
      bottom: 0;
      left: 0;
      width: 100%;
      text-align: center;
      background: rgba(0, 0, 0, 0.5);
      color: #fff;
    }
  }
}
.el-upload__tip {
  line-height: 20px;
  margin-top: 40px !important;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
  font-weight: 400;
}

.success_box {
  text-align: center;
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translateY(-50%);
  .success_img {
    width: 71.43px;
    height: 71.46px;
    margin-bottom: 15px !important;
  }
  .success_text {
    font-size: 24px;
    color: rgba(0, 0, 0, 0.85);
    line-height: 32px;
    font-weight: 500;
    margin-bottom: 48px !important;
  }
}
.authenticationY_box {
  padding: 24px 0 0 32px !important;
  .authenticationY_title {
    font-size: 16px;
    color: #000000;
    letter-spacing: 0;
    font-weight: 500;
    margin-bottom: 24px !important;
  }
  .label {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
    line-height: 22px;
    font-weight: 400;
    opacity: 0.65;
  }
  .value {
    font-size: 14px;
    color: #000000;
    line-height: 22px;
    font-weight: 400;
  }
  .state {
    font-size: 12px;
    color: #111111;
    letter-spacing: 0;
    text-align: center;
    font-weight: 400;
    margin-left: 5px !important;
  }
  .state_img {
    width: 62px;
    height: 18px;
    vertical-align: bottom;
  }
}
</style>